// Endpoints that are called without a valid session (login, phone/email cert,
// password reset, ephemeral login). A 401 from these means "wrong credentials",
// not "session expired", so the axios interceptor must not redirect on them.
//
// No leading slash: callers pass 'api/...', '/api/...' and `${HOST_API_KEY}/api/...`
// interchangeably, and a substring match covers all three.
const AUTH_EXEMPT_PATHS = [
  'api/accounts/login/',
  'api/accounts/cert/',
  'api/accounts/reset-password/',
  'api/accounts/ephemeral/',
];

export default function isAuthExemptUrl(url) {
  if (typeof url !== 'string' || url === '') {
    return false;
  }
  return AUTH_EXEMPT_PATHS.some((path) => url.includes(path));
}
